import { createStyles, FormControl, InputLabel, makeStyles, MenuItem, Select, SelectProps, Box } from '@material-ui/core';
import * as React from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import cn from 'classnames';
import { BankType, useGetOutDebtsQuery } from '../../generated/graphql';
import { getEntityLabel } from '../../utils/financialEntitiesList';
import { getDebtTypeLabel } from '../../utils/getDebtTypeLabel';
import { TranquiTheme } from '../App/theme';
import useDictionary from '../../dictionaries/context/useDictionary';
import { transformInfoBank } from './transformInfoBank';
import { useGetProductNumberDef } from '../../utils/useGetProductNumberDef';

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  root: {
    width: '100%',
  },
  menuItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '3px 6px',
    '& small': {
      fontSize: 12,
    },
  },
}));

const Item = ({ outDebt, ...props }: any) => {
  const { bank, type } = transformInfoBank(outDebt);
  const productNumberDef = useGetProductNumberDef(outDebt);
  const productNumber = outDebt.bank === BankType.BancoDeBogota
    ? productNumberDef : outDebt.productNumber;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <MenuItem {...props}>
      <small>{getEntityLabel(bank, outDebt.brand)}</small>
      <strong>
        {getDebtTypeLabel(type)}
        {' '}
        {productNumber}
      </strong>
    </MenuItem>
  );
};

interface OutDebtSelectorProps {
  className?: string;
}

const OutDebtSelector: React.FC<OutDebtSelectorProps> = ({ className }) => {
  const classes = useStyles();
  const { gT } = useDictionary();

  const { data: outDebtsData } = useGetOutDebtsQuery();
  const outDebts = outDebtsData?.outDebts || [];

  const { path, params: { debtId } } = useRouteMatch<{ debtId: string }>();
  const history = useHistory();

  const handleChange: SelectProps['onChange'] = ({ target: { value } }) => {
    history.push(path.replace(/:debtId.*/, value as string));
  };

  if (outDebts.length <= 1) return null;
  return (
    <Box className={className}>
      <FormControl className={cn(classes.root)} data-test="cy-outDebtSelector-form">
        <InputLabel>{`${gT('general_outdebt_selector_title')}`}</InputLabel>
        <Select
          value={debtId}
          onChange={handleChange}
          data-test="cy-outDebtSelector-select"
          renderValue={(value) => {
            const sel = outDebts.find(({ id }) => id === value)!;
            return (
              <Item
                className={classes.menuItem}
                outDebt={sel}
                data-test="cy-outDebtSelector-itemSelected"
              />
            );
          }}
        >
          {outDebts.map((outDebt) => (
            <Item
              value={outDebt.id}
              key={outDebt.id}
              className={classes.menuItem}
              outDebt={outDebt}
              data-test="cy-outDebtSelector-selectItem"
            />
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default OutDebtSelector;
